const classPrefix = 'main-banner'
const dataPrefix = 'data-main-banner'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    //summaryResults({$container})
    mainBanner()
}

export function mainBanner() {

    const $bannerInfoContainer = $container.querySelector(`[${dataPrefix}-info]`)

    if ($bannerInfoContainer)
    {
        const $bannerInfoContainerOpen = $bannerInfoContainer.querySelector(`[${dataPrefix}-info-open]`)
        const $bannerInfoContainerClose = $bannerInfoContainer.querySelector(`[${dataPrefix}-info-close]`)

        $bannerInfoContainerClose.addEventListener('click', ()=>{
            $bannerInfoContainer.classList.remove(`${classPrefix}__info--open`)
        })
        $bannerInfoContainerOpen.addEventListener('click', ()=>{
            $bannerInfoContainer.classList.add(`${classPrefix}__info--open`)
        })
    }

}




